import {PolicyDepartmentList} from "./PolicyDepartmentList";
import {PolicyDepartmentEdit} from "./PolicyDepartmentEdit";
import {PolicyDepartmentCreate} from "./PolicyDepartmentCreate";

export default {
    list: PolicyDepartmentList,
    create: PolicyDepartmentCreate,
    edit: PolicyDepartmentEdit
};
